import React, { useContext } from 'react';
import '../../App.css';
import { Link } from 'react-router-dom';
import { User } from '../../UserContext.js';
import {
    auth,
    database,
    app
} from "../../firebase-config.js";
import {
    onAuthStateChanged,
    signOut
} from "firebase/auth";
import $ from 'jquery';
import { onValue, ref, remove } from "firebase/database";
import Form from 'react-bootstrap/Form';
import { useState } from "react";




export default function Pefil() {
    const [user, setUser] = useContext(User);
    const [cep, setCep] = useState("");

    onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
    });

    const logout = async () => {
        await signOut(auth);
        window.location.href = '/admin'
    };

    function deleteEntry() {
        console.log("DELETING");
    }

    if (user != null) {
        const databaseRef = ref(database, 'Bolsa/' + user.uid);
        console.log(user.uid);
        onValue(databaseRef, function (snapshot) {
            if (snapshot.exists()) {
                var content = '<tr class="linhaTabela">';
                content += '<th class= "tituloTabela" > Esp&eacute;cie</th>';
                content += '<th class="tituloTabela">Nome do doador</th>';
                content += '<th class="tituloTabela">Ra&ccedil;a</th>';
                content += '<th class="tituloTabela">VG %</th>';
                content += '<th class="tituloTabela"> Data da coleta </th>';
                content += '<th class="tituloTabela"> Data de validade </th>';
                content += '<th class="tituloTabela"> Deletar</th>';
                content += '</tr >';
                snapshot.forEach(function (data) {
                    console.log(data.key)
                    var especie = data.val().especie;
                    var nomePet = data.val().nomePet;
                    var raca = data.val().raca;
                    var vg = data.val().vg;
                    var dataColeta = data.val().dataColeta;
                    var dataValidade = data.val().dataValidade;
                    content += '<tr class="linhaTabela">';
                    content += '<td class="colunaTabela">' + especie + '</td>';
                    content += '<td class="colunaTabela">' + nomePet + '</td>';
                    content += '<td class="colunaTabela">' + raca + '</td>';
                    content += '<td class="colunaTabela">' + vg + '</td>';
                    content += '<td class="colunaTabela">' + dataColeta + '</td>';
                    content += '<td class="colunaTabela">' + dataValidade + '</td>';
                    content += '<td><button id=' + data.key + ' class="XDelete"> X </button></td>';
                    content += '</tr>';
                    $('#sangueTableId').html(content);
                    $('#' + data.key).click(function () {
                        console.log("delete " + this.id)
                        remove(ref(database, 'Bolsa/' + user.uid + '/' + this.id));
                    });
                });
            }
        });
    }

    return <>
        <body className='perfil'>
            <h1 className='title'>{user?.email}</h1>
            <div class="center">
                <button className='btn--enviar' onClick={logout} >
                    Logout
                </button>
            </div>
            <div className="divTabela">
                <table className="tabelaSangue" id="sangueTableId">
                </table>
            </div>
            <div class="center">
                <Link to='/sangue'> 
                    <button className='btn--enviar'>Cadastrar Nova Bolsa</button>
                </Link>
            </div>


            <div class="center">
                <Form.Group className='formIdade' controlId="formGroupIdade">
                    <Form.Label>CEP: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setCep(event.target.value)} />
                </Form.Group>
                <Link to='/busca'>
                    <button className='btn--secondary'>Buscar Nesse CEP</button>
                </Link>
            </div>
        </body>
    </>;

}